import { create, filter, findAll, findOne, getOne, resetSave, update } from "@/store/Crud/functions/actions";
export const setPreview = async (store, preview) => {
    store.commit("SET_PREVIEW", preview);
};
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
    setPreview,
};
